import { jsxs, jsx } from "react/jsx-runtime";
const IconWarningNewSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 14",
    fill: "currentColor",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M15.14 10.508 9.825 1.473A2.122 2.122 0 0 0 8 .342a2.122 2.122 0 0 0-1.825 1.131L.86 10.508a2.102 2.102 0 0 0-.094 2.15 2.102 2.102 0 0 0 1.9 1.009h10.667a2.017 2.017 0 0 0 1.807-3.159Zm-1.807 1.825H2.667c-.734 0-1.03-.517-.658-1.149L7.324 2.15A.821.821 0 0 1 8 1.675a.821.821 0 0 1 .676.474l5.315 9.035c.371.632.076 1.15-.658 1.15Z" }),
      /* @__PURE__ */ jsx("path", { d: "M8 11a.667.667 0 1 0 0-1.333A.667.667 0 0 0 8 11Zm-.015-2.667a.666.666 0 0 0 .667-.666V5a.667.667 0 0 0-1.334 0v2.667a.666.666 0 0 0 .667.666Z" })
    ]
  }
);
export {
  IconWarningNewSvg
};
